import Marquee from "react-fast-marquee";
import { useLang } from "../lang";

export default function EditorialMarquee() {
  const { t } = useLang();
  return (
    <div className="border-b border-edge/60 py-10 md:py-14" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.concat(t.marquee).map((word, i) => (
          <span key={i} className="mx-10 flex items-center gap-10">
            <span
              className={`font-display text-5xl font-semibold uppercase tracking-tight md:text-7xl ${
                i % 2 === 0 ? "text-foreground" : "text-outline"
              }`}
            >
              {word}
            </span>
            <span className="font-display text-3xl text-signal md:text-5xl">×</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
